import { render, staticRenderFns } from "./input-box.vue?vue&type=template&id=5a48dda8&scoped=true"
import script from "./input-box.vue?vue&type=script&lang=ts&setup=true"
export * from "./input-box.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./input-box.vue?vue&type=style&index=0&id=5a48dda8&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48dda8",
  null
  
)

export default component.exports